import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { SignInOrSignupForm, Loading, RegularHeader } from '../../components';

import './style.css';

// Services
import BBAnalytics from '../../services/BBAnalytics';
import BitsyApollo from '../../services/BitsyApollo';
import Logger from '../../services/Logger';
import {
  handleSignInOrSignUpSubmit,
  handleSignInOrSignUpError,
  handleChange,
  updateFormValidity,
} from '../../services/SignInOrSignUpUtils';

import Content from '../../constants/Content';

export default class EnterAccount extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isSmsOptInSelected: false,
      signInSignUpValues: {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        phoneNumber: '',
        isSubscribedToNewsletter: !props.match.params.signUpCode,
        isAgreedToTermsAndConditions: false,
      },
      signInSignUpValidationState: {
        firstName: false,
        lastName: false,
        email: false,
        password: false,
        phoneNumber: false,
      },
      termsAndConditionsError: null,
      unknownError: null,
      userExistsError: null,
      userNotFoundError: null,
      hasBeenSubmitted: false,
      isSignIn: true,
      companyCode: null,
      corporateSignUpComplete: false,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    if (this.props.match.params.signUpCode) {
      this.setState({
        isSignIn: false,
        signUpCode: this.props.match.params.signUpCode,
      });
      this.validateCompanySignUpUrl();
    }
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error });
    Logger.error(error, { extra: errorInfo });
  }

  handleSMSOptInToggle = () => {
    this.setState((prevState) => ({
      isSmsOptInSelected: !prevState.isSmsOptInSelected,
    }));
  };

  validateCompanySignUpUrl = async () => {
    const company = await BitsyApollo.validateCompanySignUpUrl(
      this.props.match.params.signUpCode,
    );
    if (!company) {
      this.setState({
        unknownError: 'This is an invalid url. Please try again.',
      });
    } else {
      if (company.error) {
        this.setState({ unknownError: company.error.value });
      }
      this.setState({
        companyCode: company.companyCode,
        companyName: company.name,
      });
    }
  };

  handleChange = (event) => {
    const newState = handleChange(event, this.state);
    this.setState(newState);
  };

  updateFormValidity() {
    const res = updateFormValidity(this.state);
    if (res.termsAndConditionsError) {
      this.setState((prevState) => ({
        ...prevState,
        termsAndConditionsError: res.termsAndConditionsError,
      }));
    }
    return res.isValid;
  }

  goToNextStep = () => {
    this.setState({ hasBeenSubmitted: true, isLoading: true });
    const isFormValid = this.updateFormValidity();

    if (isFormValid) {
      handleSignInOrSignUpSubmit(this.state).then(async (res) => {
        if (res.error) {
          const error = handleSignInOrSignUpError(res.error);
          this.setState(error);
        } else {
          const systemCartVersion = '2.0';
          const cartVersionKey = 'cartVersion';
          const cartVersion = localStorage.getItem(cartVersionKey);

          if (!cartVersion)
            localStorage.setItem(cartVersionKey, systemCartVersion);

          this.setState({ isLoading: false });
          this.props.onLogIn();
          BBAnalytics.returningUserEvent(res, 'signin').catch((err) =>
            Logger.error(err),
          );
          if (this.state.isSmsOptInSelected) {
            BBAnalytics.optedIntoSMS().catch((err) => Logger.error(err));
          }
          this.props.onCartUpdate();
          if (this.state.companyCode) {
            this.setState({ corporateSignUpComplete: true });
          } else if (res.passwordUpdateNeeded) {
            this.props.history.push({
              pathname: '/my-account',
              state: { isShowingAccountDetails: true, isCorporate: true },
            });
          } else if (
            this.props.location.state &&
            this.props.location.state.plan
          ) {
            this.props.history.push({
              pathname: '/subscribe/select',
              state: { plan: this.props.location.state.plan },
            });
          } else if (
            this.props.location.state &&
            this.props.location.state.redirectPath
          ) {
            this.props.history.push(this.props.location.state.redirectPath);
          } else if (
            this.props.history &&
            this.props.history.location &&
            this.props.history.location.state &&
            this.props.history.location.state.shouldRedirectToPreviousPage
          ) {
            this.props.history.goBack();
          } else {
            this.props.history.push('/my-account');
          }
        }
      });
    } else {
      this.setState({ isLoading: false });
    }
  };

  redirectToSignIn = () => this.props.history.push('/signin');

  toggleSignIn = () => {
    this.setState((prevState) => ({
      isSignIn: !prevState.isSignIn,
    }));
  };

  toggleSubscriptionToNewsletter = () => {
    this.setState((prevState) => {
      const newSignInSignUpValuesState = {
        ...prevState.signInSignUpValues,
      };
      newSignInSignUpValuesState.isSubscribedToNewsletter = !prevState
        .signInSignUpValues.isSubscribedToNewsletter;
      return { signInSignUpValues: newSignInSignUpValuesState };
    });
  };

  toggleTermsAndConditions = () => {
    this.setState((prevState) => {
      const newSignInSignUpValuesState = {
        ...prevState.signInSignUpValues,
      };
      newSignInSignUpValuesState.isAgreedToTermsAndConditions = !prevState
        .signInSignUpValues.isAgreedToTermsAndConditions;
      return {
        signInSignUpValues: newSignInSignUpValuesState,
        termsAndConditionsError: null,
      };
    });
  };

  renderLoading() {
    if (this.state.isLoading) {
      return <Loading />;
    }
    return null;
  }

  handleEnter = () => {
    this.goToNextStep();
  };

  determinePageHeader = () => {
    if (this.state.isSignIn) {
      return `Sign In to ${Content.names.shortName}`;
    }
    if (this.state.companyName) {
      return `Sign Up for ${this.state.companyName} Portal`;
    }
    return `Sign Up for ${Content.names.shortName}`;
  };

  render() {
    if (this.state.corporateSignUpComplete) {
      return (
        <Container className='sign-in-component'>
          <Row className='text-center'>
            <Col
              xs={12}
              sm={12}
              md={{ span: 6, offset: 3 }}
              lg={{ span: 6, offset: 3 }}
            >
              <Row className='verificationTextMargin'>
                <div>
                  A verification link has been sent to{' '}
                  {this.state.signInSignUpValues.email}. Please visit the link
                  to complete the set up of your account.
                </div>
              </Row>
            </Col>
          </Row>
        </Container>
      );
    }
    return (
      <Container className='sign-in-component'>
        {this.renderLoading()}
        <Row>
          <Col
            xs={12}
            sm={12}
            md={{ span: 6, offset: 3 }}
            lg={{ span: 6, offset: 3 }}
          >
            <RegularHeader title={this.determinePageHeader()} />
            <Row>
              <SignInOrSignupForm
                isDisplayPhone={!this.state.isSignIn}
                toggleSubscriptionToNewsletter={
                  this.toggleSubscriptionToNewsletter
                }
                toggleTermsAndConditions={this.toggleTermsAndConditions}
                unknownError={this.state.unknownError}
                userExistsError={this.state.userExistsError}
                termsAndConditionsError={this.state.termsAndConditionsError}
                userNotFoundError={this.state.userNotFoundError}
                handleSubmit={this.goToNextStep}
                hasBeenSubmitted={this.state.hasBeenSubmitted}
                handleChange={this.handleChange}
                toggleSignIn={this.toggleSignIn}
                redirectToSignIn={this.redirectToSignIn}
                isSignIn={this.state.isSignIn}
                formValuesValidationState={
                  this.state.signInSignUpValidationState
                }
                handleEnter={this.handleEnter}
                formValues={this.state.signInSignUpValues}
                companyCode={this.state.companyName}
                handleSMSOptInToggle={this.handleSMSOptInToggle}
                isSmsOptInSelected={this.state.isSmsOptInSelected}
              />
            </Row>
          </Col>
        </Row>
      </Container>
    );
  }
}
